import { render, staticRenderFns } from "./DeviceIcon.vue?vue&type=template&id=488e8690&scoped=true&"
import script from "./DeviceIcon.vue?vue&type=script&lang=js&"
export * from "./DeviceIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488e8690",
  null
  
)

export default component.exports